import React from "react";

function BrandingPreviewCard({ primaryColour, secondaryColour }) {
  return (
    <div
      id="settings-branding-preview-card"
      className="mt-4 rounded-2xl border border-gray-200 bg-white overflow-hidden shadow-sm"
    >
      <div
        id="settings-branding-preview-header"
        className="h-14 w-full"
        style={{
          background: `linear-gradient(135deg, ${primaryColour} 0%, ${secondaryColour} 100%)`,
        }}
      />
      <div className="p-4 bg-white">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span
              id="settings-branding-preview-primary-dot"
              className="h-3.5 w-3.5 rounded-full"
              style={{ backgroundColor: primaryColour }}
            />
            <span
              id="settings-branding-preview-secondary-dot"
              className="h-3.5 w-3.5 rounded-full"
              style={{ backgroundColor: secondaryColour }}
            />
          </div>
          <div className="h-2 w-24 rounded-full bg-gray-100" />
        </div>
        <div
          id="settings-branding-preview-bar"
          className="mt-3 h-9 rounded-xl bg-gray-50 border border-gray-200 overflow-hidden"
        >
          <div
            className="h-full"
            style={{
              width: "62%",
              background: `linear-gradient(90deg, ${primaryColour}, ${secondaryColour})`,
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default BrandingPreviewCard;
